import React from "react";

export default function CollectionInfoTable() {
    return (
        <div className="mt-4">
            <div className="card text-center border-2 prod-info">
                <div className="card-header prod-info">
                    <ul
                        className="nav nav-pills nav-fill justify-content-center card-header-pills"
                        id="pills-tab"
                        role="tablist"
                    >
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link active py-3 text-uppercase fw-bold"
                                id="pills-specsheet-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-specsheet"
                                type="button"
                                role="tab"
                                aria-controls="pills-specsheet"
                                aria-selected="true"
                            >
                                Spec Sheet
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link py-3 text-uppercase fw-bold"
                                id="pills-photometry-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-photometry"
                                type="button"
                                role="tab"
                                aria-controls="pills-photometry"
                                aria-selected="false"
                            >
                                Photometry
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link py-3 text-uppercase fw-bold"
                                id="pills-installation-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-installation"
                                type="button"
                                role="tab"
                                aria-controls="pills-installation"
                                aria-selected="false"
                            >
                                Installation Instructions
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link py-3 text-uppercase fw-bold"
                                id="pills-accesories-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-accessories"
                                type="button"
                                role="tab"
                                aria-controls="pills-accessories"
                                aria-selected="false"
                            >
                                Accessories
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link py-3 text-uppercase fw-bold"
                                id="pills-literature-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-literature"
                                type="button"
                                role="tab"
                                aria-controls="pills-literature"
                                aria-selected="false"
                            >
                                Literature
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link py-3 text-uppercase fw-bold"
                                id="pills-gallery-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-gallery"
                                type="button"
                                role="tab"
                                aria-controls="pills-gallery"
                                aria-selected="false"
                            >
                                Gallery
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link py-3 text-uppercase fw-bold"
                                id="pills-videos-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-videos"
                                type="button"
                                role="tab"
                                aria-controls="pills-videos"
                                aria-selected="false"
                            >
                                Videos
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link py-3 text-uppercase fw-bold"
                                id="pills-layout-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-layout"
                                type="button"
                                role="tab"
                                aria-controls="pills-layout"
                                aria-selected="false"
                            >
                                Request a layout
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link py-3 text-uppercase fw-bold"
                                id="pills-certs-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-certs"
                                type="button"
                                role="tab"
                                aria-controls="pills-certs"
                                aria-selected="false"
                            >
                                Certs
                            </a>
                        </li>
                    </ul>
                </div>
                <div
                    id="pills-tabContent"
                    className="card-body tab-content"
                    style={{ minHeight: "250px" }}
                >
                    <div
                        className="tab-pane fade show active"
                        id="pills-specsheet"
                        role="tabpanel"
                        aria-labelledby="pills-specsheet-tab"
                    >
                        <h1>Spec Sheet</h1>
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-photometry"
                        role="tabpanel"
                        aria-labelledby="pills-photometry-tab"
                    >
                        <h1>Photometry</h1>
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-installation"
                        role="tabpanel"
                        aria-labelledby="pills-installation-tab"
                    >
                        <h1>Installation Instructions</h1>
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-accessories"
                        role="tabpanel"
                        aria-labelledby="pills-accessories-tab"
                    >
                        <h1>Accesories</h1>
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-literature"
                        role="tabpanel"
                        aria-labelledby="pills-literature-tab"
                    >
                        <h1>Literature</h1>
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-gallery"
                        role="tabpanel"
                        aria-labelledby="pills-gallery-tab"
                    >
                        <h1>Gallery</h1>
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-videos"
                        role="tabpanel"
                        aria-labelledby="pills-videos-tab"
                    >
                        <h1>Videos</h1>
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-layout"
                        role="tabpanel"
                        aria-labelledby="pills-layout-tab"
                    >
                        <h1>Request a Layout</h1>
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-certs"
                        role="tabpanel"
                        aria-labelledby="pills-certs-tab"
                    >
                        <h1>Certs</h1>
                    </div>
                </div>
            </div>
        </div>
    );
}
